import React, { useState } from 'react';
import styles from "./RegistrationForm.module.css";
import BreatheEV_Logo from '../Images/logo.png';
import { Image } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { BreathAPIs } from '../APIs/BreathAPIs'
import { ButtonCustom } from '../BootstrapComponents/ButtonCustom';


const ForgotPassword = (props) => {
    const { verificationToken } = useParams();
    const [verificationStatus, setVerificationStatus] = useState('');


    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')

    const [isEmailSend, setIsEmailSend] = useState(false);
    const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
    const [email, setEmail] = useState('');

      function isValidPassword(password) {
        if (password.length < 12) {
          return false;
        }

        const hasUppercase = /[A-Z]/.test(password);

        const hasNumber = /\d/.test(password);

        return hasUppercase && hasNumber;
      }
    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const sendVerificationEmail = () => {
        if (!isValidEmail(email)) {
            setVerificationStatus('Please enter a valid email address.');
            return;
        }
        setIsEmailSend(null);
        BreathAPIs.forgotPassword(email)
            .then(response => {
                if (response && response.data && response.data.success) {
                    setVerificationStatus(response.data.message);
                    setIsEmailSend(true);
                } else {
                    const errorMessage = response.data && response.data.message
                        ? response.data.message
                        : 'Failed to resend verification email. Please try again.';
                    setVerificationStatus(errorMessage);
                    setIsEmailSend(false);
                }
            })
            .catch(error => {
                console.error('Error resending verification email:', error);
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'An error occurred while resending the verification email. Please try again.';
                setVerificationStatus(errorMessage);
                setIsEmailSend(false);
            });
    };

    const updatePassword = () => {
        if (!password || !password2) {
            setVerificationStatus("Please fill in all the fields.");
            return;
        } else if(!isValidPassword(password)) {
            setVerificationStatus("Password must be atleast 12 characters long, with atleast one uppercase letter and one number.");
            return;
        }
        else if (password !== password2) {
            setVerificationStatus("Passwords do not match.");
            return;
        }

        setIsPasswordUpdated(null);

        BreathAPIs.forgotPasswordUpdate(password, verificationToken)
            .then(response => {
                if (response && response.data && response.data.success) {
                    setVerificationStatus("Password updated successfully.");
                    setIsPasswordUpdated(true);
                } else {
                    const errorMessage = response && response.data && response.data.message
                        ? response.data.message
                        : 'Failed to update password. Please try again.';
                    setVerificationStatus(errorMessage);
                    setIsPasswordUpdated(false);
                }
            })
            .catch(error => {
                console.error('Error updating password:', error);
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'An error occurred while updating the password. Please try again.';
                setVerificationStatus(errorMessage);
                setIsPasswordUpdated(false);
            });
    };

    return (
        <section className="bg-light py-3 py-md-5 py-xl-8 min-vh-100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4">
                        <div className="mb-5">
                            <div className="text-center mb-4">
                                <Image className={styles['logo']} src={BreatheEV_Logo} alt="BreatheEV" />
                            </div>
                        </div>

                        <div className="card border border-light-subtle rounded-4">
                            <div className="card-body p-3 p-md-4 p-xl-5">
                                <h5 className={`mb-4 ${styles['login-title']}`}>Forgot Password ?</h5>
                                <div className="row gy-3 overflow-hidden">
                                    <div className="col-12 text-center">
                                        <div className='mb-3'>{verificationStatus}</div>

                                        {verificationToken === "verify" ? <div>
                                            {!isEmailSend && <div className="col-12 mt-3">
                                                <div className="form-floating mb-3">
                                                    <input className="form-control" type="email" name="email" placeholder='Email' onChange={(e) => { setEmail(e.target.value); }} value={email} required />
                                                    <label htmlFor="email" className="form-label">Email</label>
                                                </div>
                                                <ButtonCustom
                                                    variant={"primary"}
                                                    text={"Send verification email"}
                                                    isLoading={isEmailSend === null ? true : false}
                                                    onClick={sendVerificationEmail} />
                                            </div>}
                                        </div> : <div>
                                            {!isPasswordUpdated && <>
                                                <div className="col-12">
                                                    <div className="form-floating mb-3">
                                                        <input className="form-control" type="password" name="password" placeholder='Password' onChange={(e) => { setPassword(e.target.value); }} value={password} required />
                                                        <label htmlFor="password" className="form-label">Enter new password</label>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="form-floating mb-3">
                                                        <input className="form-control" type="password" name="password2" placeholder=' Re-enter Password' onChange={(e) => { setPassword2(e.target.value); }} value={password2} required />
                                                        <label htmlFor="password2" className="form-label"> Re-enter Password</label>
                                                    </div>
                                                </div>

                                                <ButtonCustom
                                                    variant={"primary"}
                                                    text={"Update Password"}
                                                    isLoading={isPasswordUpdated === null ? true : false}
                                                    onClick={updatePassword} />
                                            </>}

                                        </div>}

                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-center align-items-center mt-4">
                            <Link className="link-secondary text-decoration-none" to={`${process.env.REACT_APP_BASE_URL}/login`}>Back to Log in</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ForgotPassword;
